import React from 'react';
import { styled } from '@mui/material/styles';
import { CONSTANTS } from 'src/components/Constants';
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';

const size = 17;

const EmailSentChip = styled(FiberManualRecord)({
  color: '#379fb4',
  width: size,
  '&:hover': {
    transform: 'scale(1.2)'
  }
});

const InProgressChip = styled(FiberManualRecord)({
  color: '#f8dc2e',
  width: size,
  '&:hover': {
    transform: 'scale(1.2)'
  }
});

const SubmittedChip = styled(FiberManualRecord)({
  color: '#43b480',
  width: size,
  '&:hover': {
    transform: 'scale(1.2)'
  }
});

const ImportedChip = styled(FiberManualRecord)({
  color: '#fff',
  backgroundColor: '#2BA9BF'
});

const LinkCreatedChip = styled(FiberManualRecord)({
  color: '#96cfda',
  width: size,
  '&:hover': {
    transform: 'scale(1.2)'
  }
});

const DeactivatedChip = styled(FiberManualRecord)({
  color: '#e41a52',
  width: size,
  '&:hover': {
    transform: 'scale(1.2)'
  }
});

const DefaultChip = styled(FiberManualRecord)({
  color: '#efefe7',
  width: size
});

export default function UsersTableProgressCol({ status }) {
  switch (status) {
    case CONSTANTS.user_status.DEACTIVATED:
      return <DeactivatedChip />;
    case CONSTANTS.user_status.CREATED:
      return <LinkCreatedChip />;
    case CONSTANTS.user_status.PENDING:
      return <EmailSentChip />;
    case CONSTANTS.user_status.IN_PROGRESS:
      return <InProgressChip />;
    case CONSTANTS.user_status.SUBMITTED:
      return <SubmittedChip />;
    case CONSTANTS.user_status.IMPORTED:
      return <ImportedChip />;
    default:
      return <DefaultChip />;
  }
}
